<div class="pre-survey-container">

    <div class="box-info-container">
        <app-box-info>
            <p>
                Le polizze vita rivalutabili sono costituite da una <b>componente finanziaria</b>, 
                finalizzata all'accrescimento nel tempo del capitale corrisposto, e da una <b>componente 
                assicurativa</b>, che offre coperture in caso si verifichino gli eventi assicurati.
            </p>
            <p>
                Il percorso guidato di Milano Finanza ti aiuta a <b>individuare in pochi minuti</b>, in 
                modo semplice e assistito, le polizze vita ramo I, ramo III, ramo V o multiramo che
                soddisfano le tue esigenze, accompagnandoti nella vasta scelta tra i prodotti presenti
                sul mercato.
            </p>
            <p>
                Il <b>percorso si compone di tre parti</b>, oltre a quella relativa al risultato finale, che puoi 
                vedere scorrere in alto: <b>caratteristiche generali, coperture assicurative</b> e 
                <b>prestazioni finanziarie</b>, cliccabili per tornare indietro e cambiare le scelte già fatte. 
                Oppure puoi cambiarle cliccando sulle barre blu, che indicano visivamente quanti 
                prodotti residuano progressivamente (numero in rosso) per ogni scelta contenuta nelle 
                risposta fornite. Nella pagina del <b>risultato della comparazione</b> potrai cliccare su 
                ciascun prodotto che soddisfa le tue scelte per vedere tutti i dettagli, scaricabili anche 
                in formato pdf.
            </p>
            <p>
                Al termine, o anche se non hai terminato, <b>puoi salvare</b> quanto fatto dando un nome a 
                ciascun processo di comparazione completo o parziale. <b>Ogni domanda è cliccabile 
                per visualizzarne la spiegazione</b> e il tutor virtuale ti guiderà quando necessario.
            </p>
            <br />
            <!-- <p>
                <b>Clicca sul pulsante Inizia sottostante per cominciare il percorso guidato.</b>
            </p> -->
    
            <div class="btn-container">
                <app-btn txtAlign="center" color="mf-primary" (click)="iniziaClicked()" padding="8px 36px">
                    <span class="btn-txt">Inizia il percorso guidato</span>
                </app-btn>
            </div>
        </app-box-info>
    </div>

</div>